import React from "react";
import { Search } from "lucide-react";
import SizeSelector from "./SizeSelector";
import ColorSelector from "./ColorSelector";

const SIZES = ["S", "M", "L", "XL", "XXL"];

const FilterSidebar = ({
  size,
  onSizeChange,
  color,
  onColorChange,
  colorOptions,
  maxPrice,
  onMaxPriceChange,
  sort,
  onSortChange,
  onClear,
  search = "",
  onSearchChange,
  showSearch = false,
  onApply,
  compact = false,
  className = "",
}) => (
  <aside className={`${compact ? "space-y-5" : "space-y-6 rounded-[8px] border border-white/10 bg-cynos-card p-4 lg:sticky lg:top-24 lg:self-start"} ${className}`} data-testid="filters">
    {showSearch && (
      <div>
        <h3 className="mb-3 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Search</h3>
        <div className="flex min-h-[48px] items-center gap-3 rounded-[8px] border border-white/15 bg-black px-4">
          <Search size={15} className="text-zinc-500" />
          <input
            value={search}
            onChange={(event) => onSearchChange?.(event.target.value)}
            placeholder="Search drops"
            className="w-full bg-transparent font-mono text-xs uppercase tracking-[0.18em] outline-none placeholder:text-zinc-600"
            data-testid="mobile-filter-search"
          />
        </div>
      </div>
    )}
    <div>
      <h3 className="mb-3 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Size</h3>
      <SizeSelector sizes={SIZES} value={size} onChange={onSizeChange} allLabel="All" />
    </div>
    <div>
      <h3 className="mb-3 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Color</h3>
      <ColorSelector colors={colorOptions} value={color} onChange={onColorChange} allLabel="All" />
    </div>
    <div>
      <h3 className="mb-3 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Max Price - {"\u20b9"}{maxPrice}</h3>
      <input
        type="range"
        min="299"
        max="2000"
        step="50"
        value={maxPrice}
        onChange={(e) => onMaxPriceChange(parseInt(e.target.value, 10))}
        className="w-full accent-cynos-red"
        aria-label="Maximum price"
        data-testid="price-slider"
      />
    </div>
    <div>
      <h3 className="mb-3 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">Sort</h3>
      <select
        value={sort}
        onChange={(e) => onSortChange(e.target.value)}
        className="min-h-[48px] w-full rounded-[8px] border border-white/15 bg-cynos-surface px-3 py-3 font-mono text-sm uppercase outline-none focus:border-white"
        data-testid="sort-select"
      >
        <option value="newest">Newest</option>
        <option value="best_selling">Best Selling</option>
        <option value="price_asc">Price: Low to High</option>
        <option value="price_desc">Price: High to Low</option>
      </select>
    </div>
    <div className="grid gap-2">
      {onApply && (
        <button type="button" onClick={onApply} className="min-h-[48px] w-full rounded-[8px] bg-cynos-red px-4 py-3 font-mono text-xs uppercase tracking-[0.2em] text-white hover:bg-red-600" data-testid="apply-filters">
          Apply Filters
        </button>
      )}
      <button type="button" onClick={onClear} className="min-h-[48px] w-full rounded-[8px] border border-white/20 px-4 py-3 font-mono text-xs uppercase tracking-[0.2em] hover:border-white" data-testid="clear-filters">
        {compact ? "Clear Filters" : "Reset Filters"}
      </button>
    </div>
  </aside>
);

export default FilterSidebar;
